__turbopack_context__.v({
  "capitalize": "dXTYdG_capitalize",
  "modalBody": "dXTYdG_modalBody",
  "modalBodyWidth400": "dXTYdG_modalBodyWidth400",
  "modalFooter": "dXTYdG_modalFooter",
  "orderFormatsGrid": "dXTYdG_orderFormatsGrid",
  "orderTimeSection": "dXTYdG_orderTimeSection",
  "row": "dXTYdG_row",
  "scheduleButton": "dXTYdG_scheduleButton",
  "subTitle": "dXTYdG_subTitle",
});
